import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import { Event } from 'api/mo/mo.types';
import { AppTable, AppTableColumn } from 'components/table/appTable';
import { MoEventsListTableProps } from './MoEventsListTable.types';

const formatValue = (value: any) => value || 'n/a';

const columns: (props: MoEventsListTableProps) => AppTableColumn[] = ({ match }) => [
  {
    Header: 'Event Data',
    columns: [
      {
        Header: 'Id',
        id: 'id',
        accessor: (event: Event) => event.id,
      },
      {
        Cell: (row: { original: Event }) => (
          <Link to={`${match.path}/${row.original.id}`}>
            <strong>{row.original.name}</strong>
          </Link>
        ),
        Header: 'Name',
        id: 'name',
        accessor: (event: Event) => formatValue(event.name),
      },
      {
        Header: 'Client',
        id: 'clientName',
        accessor: (event: Event) => formatValue(event.clientName),
      },
    ],
  },
];

const MoEventsListTable = (props: MoEventsListTableProps) => {
  const { data } = props;

  return (
    <AppTable
      defaultSorted={[{ id: 'clientName', desc: false }]}
      columns={columns(props)}
      data={data}
      tableName="events"
      noDataText="No data to display"
      defaultPageSize={10}
    />
  );
};

export const TableContainer = withRouter(MoEventsListTable);
